import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { EYesNo } from '../../../../../shared/models/types.enum';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { FormUtils } from '../../../../../shared/helpers/formUtils';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'section-a',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './section-a.component.html',
  styleUrl: './section-a.component.css'
})
export class SectionAComponent implements OnInit, OnChanges {

  @Input() fullTeamAssessmentData: any;
  @Output() onSaveSection3 = new EventEmitter<any>();

  yesNo = EYesNo;
  sectionAForm: FormGroup = new FormGroup([]);
  questionList = [
    {
      question: "What motivated the student to communicate the threat or take the concerning actions resulting in the assessment? *",
      formControlName: "student_motivation",
    }
  ]

  radioQuestions = [
    {
      id: 'ongoing_threat',
      questionText: 'Is the threat ongoing? *',
      formControlName: 'ongoing_threat',
      infoFormControlName: 'ongoing_threat_explanation',
      label: 'Please explain: *'
    },
    {
      id: 'threat_resolution',
      questionText: 'Has any part of the threat been resolved? *',
      formControlName: 'threat_resolution',
      infoFormControlName: 'threat_resolution_explanation',
      label: 'Please explain: *'
    }
  ];

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private formUtils: FormUtils
  ) {}

  ngOnInit() {
    this.initializeForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['fullTeamAssessmentData'] && this.fullTeamAssessmentData) {
      this.initializeForm();
    }
  }

  private initializeForm() {
    const group: any = {};
    
    this.radioQuestions.forEach(question => {
      group[question.formControlName] = new FormControl(String(this.fullTeamAssessmentData?.[question.formControlName]) || this.yesNo.No, Validators.required);
      group[question.infoFormControlName] = new FormControl({ value: this.fullTeamAssessmentData?.[question.infoFormControlName] || '', disabled: this.fullTeamAssessmentData?.[question.infoFormControlName] ? false: true });
    });
    this.questionList.forEach(question => {
      group[question.formControlName] = new FormControl(this.fullTeamAssessmentData?.[question.formControlName] || '', Validators.required);
    });
    group['a_additional_info'] = new FormControl(String(this.fullTeamAssessmentData?.a_additional_info) || this.yesNo.No, Validators.required);

    this.sectionAForm = new FormGroup(group);
    this.setupFormChangeHandlers();
  }

  setupFormChangeHandlers() {
    this.radioQuestions.forEach(question => {
      const control = this.sectionAForm.get(question.formControlName);
      if (control) {
        control.valueChanges.subscribe(value => {
          const infoControl = this.sectionAForm.get(question.infoFormControlName);
          if (infoControl) {
            this.formUtils.handleConditionChange(infoControl, value === this.yesNo.Yes);
          }
        });
      }
    });
  }

  saveSectionA(): void {
    if (this.sectionAForm.valid) {
        this.onSaveSection3.emit(this.sectionAForm.value);
    }
  }

}
